var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavigationArrowIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#96999E",
    d: "m13.9419 3.1748-4.106 10.2881c-.2913.771-1.4039.6912-1.6158-.1063L7.187 9.3956c-.0795-.2925-.318-.5318-.6093-.6115l-3.947-1.0368c-.7947-.2127-.8477-1.3026-.106-1.6216l10.3047-4.0674c.6887-.2659 1.3774.4253 1.1125 1.1165"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavigationArrowIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/navigation-arrow-icon.7ac3e0275d6ebd5c472e1a28ae680a66.svg";